import React from 'react'
import styles from './UIGameEndHeader.module.scss'
import {AdBox} from './AdBox/index.ts'
import {Logo} from './Logo/index.ts'
import {FADE_IN_ANIMATION_DELAYS} from '../constants.ts'
import {FadeInContainer} from '../../../common/FadeInContainer/index.ts'
import {MapReplayButton} from './ActionButtons/MapReplayButton.tsx'
import {ShareButton} from './ActionButtons/ShareButton.tsx'
import {GameResultsControlsShareButton} from '../../UIGameGameResultsControls/GameResultsControlsShareButton.tsx'
import {useUIGlobalContext} from '@colonist/ui'
import clsx from 'clsx'

interface UIGameEndHeaderProps {
    disableAnimation: boolean
    onClickShareGameResults: () => void
}

export function UIGameEndHeader({
    disableAnimation,
    onClickShareGameResults,
}: UIGameEndHeaderProps) {
    const {isUserOnMobileAppOrWeb} = useUIGlobalContext()
    return (
        <div className={styles.header}>
            <FadeInContainer
                animationDelayMs={FADE_IN_ANIMATION_DELAYS.ads}
                animationDurationMs={FADE_IN_ANIMATION_DELAYS.transitionDuration}
                disableAnimation={disableAnimation}
                className={styles.leftFadeInContainer}
                id='endgame-item-box'>
                <AdBox className={styles.adBox}/>
                <MapReplayButton
                    text='strings:game.endGame.cornerButton.map'
                    className={clsx(styles.leftMapReplayButtonContainer, {[styles.mobileEntry]: isUserOnMobileAppOrWeb})}/>
            </FadeInContainer>
            <Logo disableAnimation={disableAnimation}/>
            <FadeInContainer
                animationDelayMs={FADE_IN_ANIMATION_DELAYS.topLeftButtons}
                animationDurationMs={FADE_IN_ANIMATION_DELAYS.transitionDuration}
                disableAnimation={disableAnimation}>
                <div className={clsx(styles.rightActionButtonsContainer, {[styles.mobileEntry]: isUserOnMobileAppOrWeb})}>
                    <MapReplayButton text='strings:game.endGame.cornerButton.mapWithReplay'/>
                    <ShareButton />
                </div>
                <div className={clsx(styles.rightShareButtonContainer, {[styles.mobileEntry]: isUserOnMobileAppOrWeb})}>
                    <GameResultsControlsShareButton
                        onShare={onClickShareGameResults}
                        spinnerClassName={styles.spinner}
                    />
                </div>
            </FadeInContainer>
        </div>
    )
}
